import React from 'react'
import { graphql } from 'gatsby'
import Layout from "../components/layout"
import SEO from "../components/seo"
import BioDetail from "../components/bio-detail"
import InterventiProgramma from "../components/interventi-programma"
// import Newsletter from "../components/newsletter"
// import Banner from "../components/banner"


const Speaker = ({ pageContext: { title, locale }, data }) => {
  const interventi = data.interventi.edges.map(edge => edge.node);
  const interventiDoppioRel = data.interventiDoppioRel.nodes;
  const interventiProgramma = interventi.filter(item => item.pageslug).concat(interventiDoppioRel.filter(item => item.pageslug));
  return (
    <Layout locale={locale}>
      <SEO title={title} />
      {(!!data.interventi) &&
        <>
          <BioDetail speaker={data.speaker} intervento={interventiProgramma[0]} />
          {interventiProgramma.length && <InterventiProgramma interventi={interventiProgramma} />}
        </>
      }
      {/* <Newsletter /> */}
     {/*  <Banner /> */}
    </Layout>
  )
};

export const query = graphql`
  query SpeakerQuery($title: String!, $locale: String!) {
    speaker: speakerYaml(title: {eq: $title}, lang: {eq: $locale}){
      title
      jobtitle
      bio
      linkedin
      twitter
      website
      pubblicazioni
      img
      imageFile {
        childImageSharp {
          fluid(maxWidth: 260, quality: 100){
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      workshop
      casestudy
      keynote
      socialconsulting
    }  
    interventi: allInterventiYaml(filter: {relatore: {eq: $title}, lang: {eq: $locale}}){
      edges {
        node {
          title
          pageslug
          orario
          orariodesc
          day
          luogo
          tipologia
          abstract
          description
        }
      }
    }
    interventiDoppioRel: allInterventiYaml(filter: {relatori: {in: [$title]}, lang: {eq: $locale}}){
      nodes {
        title
        pageslug
        orario
        orariodesc
        day
        luogo
        tipologia
        abstract
        description
      }
    }
  }
`;

export default Speaker;
